import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

function CustomersPage() {
  const history = useHistory();
  const routeMatch = useRouteMatch();

  useEffect(() => {
    if (routeMatch.path === '/app/customers') {
      history.push('/app/customers/list');
    }
  }, [history]);

  return null;
}

export default CustomersPage;
